import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../service/api.js";
import router from "../../../router/index.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        item : []
    },

    mutations: {
        campus(state, obj) {
            state.item = obj;
        }
    },

    actions: {
        config({commit}, data) {
            return Service.campus('exp', {}, {})
                .then((response) => {
                    //
                    // var lang = store.getters['setting/lang']
                    // var items = [];
                    // response.data.data.filter(item => {
                    //     var objs = item.title.filter(title => {
                    //         if(title.key == lang){
                    //             return title
                    //         }
                    //     })[0].value;
                    //     var data = {};
                    //     data.label = objs
                    //     data.value = item._id;
                    //     items.push(data)
                    // })
                    store.commit("campus/campus", [])
                    store.commit("campus/campus", response.data.data)
                    return response

                }).catch((err) => {
            });
        },
        create({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.campus('post', {...data}, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    return store.dispatch("campus/config", {}).then(() => response)
                }).catch((err) => {
                    store.commit("dialog/loading",false)
            });
        },
        update({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.campus('put', data, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    return store.dispatch("campus/config", {}).then(() => response)
                }).catch((err) => {
                    store.commit("dialog/loading",false)
            });
        },
    },

    getters: {
        campus(state, obj) {
            return state.item;
        },
    },
};

export default ServerModule;
